/**
 * De kant-en-klare configuraties voor de bekende AI-agents, als tekst om te kopiëren.
 *
 * Los van het scherm, zodat een test kan nagaan dat er echt het adres en de sleutel in
 * staan. De sleutel gaat steeds als Bearer-header mee; Claude Desktop praat via
 * `mcp-remote`, omdat zijn eigen connectors geen eigen header kennen.
 */
export const KEY_PLACEHOLDER = 'SK_LIVE_JOUW_SLEUTEL';

export interface ConnectTarget {
    /** De naam waaronder de server in de agent staat: `smartkeur` of `smartkeur-beheer`. */
    serverName: string;
    mcpUrl: string;
    /** De sleutel zelf als hij net gemaakt is, anders de plaatshouder. */
    key: string | null;
}

function keyOf(target: ConnectTarget): string {
    return target.key ?? KEY_PLACEHOLDER;
}

export function claudeDesktopConfig(target: ConnectTarget): string {
    return JSON.stringify(
        {
            mcpServers: {
                [target.serverName]: {
                    command: 'npx',
                    args: [
                        '-y',
                        'mcp-remote',
                        target.mcpUrl,
                        '--header',
                        'Authorization:${SMARTKEUR_AUTH}',
                    ],
                    env: { SMARTKEUR_AUTH: `Bearer ${keyOf(target)}` },
                },
            },
        },
        null,
        2,
    );
}

export function claudeCodeCommand(target: ConnectTarget): string {
    return `claude mcp add --transport http ${target.serverName} ${target.mcpUrl} --header "Authorization: Bearer ${keyOf(target)}"`;
}

export function cursorConfig(target: ConnectTarget): string {
    return JSON.stringify(
        {
            mcpServers: {
                [target.serverName]: {
                    url: target.mcpUrl,
                    headers: { Authorization: `Bearer ${keyOf(target)}` },
                },
            },
        },
        null,
        2,
    );
}
